import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Help from "../Help";
import Header from "../Header";
import RaiseQueries from "./RaiseQueries";
import ViewQueries from "./ViewQueries";
import topImg from "../../Assets/svg/topVector.svg";
import btmImg from "../../Assets/svg/bottomVector.svg";
import FooterText from "../modules/FooterText";
import UpdateQueries from "./UpdateQueries";
import ModalComponent from "../modules/Modal";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Button from "../modules/Button";

export default function LoggedQueries(props) {
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });  

  return (
    <div className="form-div help-section">
      {/* <Header isLogin={true} /> */}
      <div className="help-content">
        {/* <Help /> */}
      
      <Routes>
        <Route exact path="/" element={<Help loggedIn={true} />} />
        <Route exact path="/raise-queries" element={<RaiseQueries />} />
        <Route exact path="/update-queries" element={<UpdateQueries 
        showModal={(e) => showModal({ ...isModal, show: true, msg: e })}
        
        />} />
        <Route exact path="/view-queries" element={<ViewQueries />} />
        <Route path="*" element={<Help loggedIn={true} />} /> 

      </Routes>
      </div>
      <FooterText/>
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been uploaded successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
           
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>

        </ModalComponent>
      )}
    </div>
  );
}
